/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import { ReferenceGroup } from '../Utility/Component/ComponentReference/ReferenceGroup';
import SwitcherComponentBase from '../Utility/Component/SwitcherComponentBase';
import IPlaybar from './IPlaybar';
import PlaybarManager from './PlaybarManager';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Controls the various UI components and behaviour of the playbar. */
@cc._decorator.ccclass
export default class PlaybarSwitcher extends SwitcherComponentBase<IPlaybar> implements IPlaybar
{
    @property({ type: InjectableComponent, visible: true })
    protected landscapePlaybarRef: InjectableComponent<IPlaybar>
        = new InjectableComponent(ReferenceGroup.MainGame, "Playbar.Landscape");

    @property({ type: InjectableComponent, visible: true })
    protected portraitPlaybarRef: InjectableComponent<IPlaybar>
        = new InjectableComponent(ReferenceGroup.MainGame, "Playbar.Portrait");

    /** Public accessor to whether interacteable. */
    public get IsLocked(): boolean
    {
        if (!this.items || this.items.length < 1) { return false; }

        const firstIsLocked: boolean = this.items[0].WithValue(playbar => playbar.IsLocked, false);

        if (this.items.some(ref => ref.WithValue(playbar => playbar.IsLocked !== firstIsLocked)))
        {
            throw new Error('Playbar locks out of sync.');
        }

        return firstIsLocked;
    }

    /** @hidden */
    protected setContexts(): void
    {
        super.setContexts();
        this.items.push(this.landscapePlaybarRef.SetContext(PlaybarManager));
        this.items.push(this.portraitPlaybarRef.SetContext(PlaybarManager));
    }

    protected updateDisplay(): void
    {
        this.landscapePlaybarRef.WithValue(playbar =>
            {
                playbar.node.active = this.canvasRef.WithValue(canvas => canvas.IsLandScape, true);
            });

        this.portraitPlaybarRef.WithValue(playbar =>
            {
                playbar.node.active = this.canvasRef.WithValue(canvas => !canvas.IsLandScape, false);
            });
    }

    public HidePlayButton(): void
    {
        this.forEachItem(playbar => playbar.HidePlayButton());
    }

    public ShowPlayButton(): void
    {
        this.forEachItem(playbar => playbar.ShowPlayButton());
    }

    /** Enables playbar buttons and other interacteable items. */
    public ToggleOn(): void
    {
        this.forEachItem(playbar => playbar.ToggleOn());
    }

    /** Disables playbar buttons and other interacteable items. */
    public ToggleOff(excludeMenuButton: boolean = false): void
    {
        this.forEachItem(playbar => playbar.ToggleOff(excludeMenuButton));
    }
}
